<template>
  <header id="page-header" class="page-header" role="banner">
    <section class="page-header-section">
      <!-- logo -->
      <!--      <div class="img-box">-->
      <img
        v-if="i18n.locale === 'fr_CA'"
        src="~img/new-logo-visa-fr.svg"
        :class="['page-header-logo', { nolink: isFromPortal }]"
        alt="logoimage"
        @click="logoClick"
      />
      <img
        v-else
        src="~img/new-logo-visa.svg"
        :class="['page-header-logo', { nolink: isFromPortal }]"
        alt="logoimage"
        @click="logoClick"
      />
      <!--        <img v-if="bankLogo" :src="bankLogo" class="bank-logo" alt="banklogo" />-->
      <!--      </div>-->
      <div class="wrapper" v-if="!isFromPortal">
        <div v-if="!userInfo" class="mobile-login" @click="loginModalShow">{{ $t('login') }}</div>
        <img
          src="~img/home-search@2x.png"
          class="page-header-search"
          alt="search"
          @click="toggleSearch"
        />
        <!--由于main.js有fastclick，不需要再做touchstart事件了，影响transition的事件
（影响整个元素是否展示的，应该加上.stop，iOS手机好像默认会阻止冒泡，安卓不会，否则安卓将会）-->
        <img
          src="~img/iconMenu@2x.png"
          class="page-header-menu"
          alt="menu"
          @click.stop="openMenu"
        />
      </div>
      <!--      变量控制mobile样式-->
      <div class="page-header-tool" v-if="!isFromPortal">
        <!-- search-box -->
        <search
          v-if="!hideSearch"
          :placeholder="$t('search-airport')"
          :listData="searchLish"
          @searchClick="handleSearchClick"
        >
        </search>

        <!-- list -->
        <nav class="page-header-list" role="navigation">
          <button role="button" class="lounge-btn" @click="handleLounge">
            {{ $t('lounge') }}
          </button>
          <button role="button" @click="handleBenefits">{{ $t('benefits') }}</button>

          <dropdown
            :list="engDropDownList"
            :title="languageTitle"
            class="eng-drop-down"
            @drowDownClick="drowDownClick"
          >
          </dropdown>

          <button v-if="!isLogin" role="button" @click="handleSignup" class="sign-up">
            {{ $t('sign-up') }}
          </button>

          <button v-if="!isLogin" role="button" @click="loginModalShow" class="login-btn">
            {{ $t('login') }}
          </button>

          <dropdown
            :list="userDropDownList"
            :title="userInfo.firstName"
            :fontStyle="fontStyle"
            :userIcon="userInfo.head"
            :showHeadIcon="true"
            v-if="isLogin"
            class="eng-drop-down"
            @drowDownClick="handleUserDropDownList"
          >
          </dropdown>
        </nav>
      </div>
    </section>
    <div v-if="isSearchShow" v-clickOutside="popoverOutsideClick">
      <search
        :placeholder="$t('search-airport')"
        :listData="searchLish"
        @searchClick="handleSearchClick"
        :mobileClass="mobileClass"
        class="search"
      />
    </div>
  </header>
</template>

<script>
  import i18n from '@/i18n';
  import { mapState, mapMutations } from 'vuex';
  import store from '@/store';
  import Search from '@/components/BaseUi/Search/index.vue';
  import Dropdown from '@/components/BaseUi/Dropdown/index.vue';
  import { updateQueryString } from '@/utils';
  import { clickOutside } from '@/utils/directive';
  // import mobilePageHeadMenu from '@/components/BaseUi/MobilePageHeadMenu';

  export default {
    directives: {
      clickOutside,
    },
    data() {
      return {
        i18n,
        isSearchShow: false,
        userDropDownList: [
          { key: 'ma', label: 'head-user-dropdown-account' },
          { key: 'vp', label: 'head-user-dropdown-visited' },
          { key: 'notify', label: 'head-user-dropdown-notify' },
          { key: 'lo', label: 'head-user-dropdown-logout' },
        ],
        fontStyle: {
          color: '#C29D5C',
          fontWeight: '600',
        },
        searchLish: [],
        mobileClass: {
          width: '89%',
          margin: 'auto',
        },
        hideSearch: false,
      };
    },

    components: {
      Search,
      Dropdown,
    },

    watch: {
      $route: {
        handler(newVal) {
          if (newVal.name === 'SignUp' || newVal.name === 'Login') {
            this.hideSearch = true;
          } else {
            this.hideSearch = false;
          }
        },
        immediate: true,
      },
      isLogin: {
        handler() {
          this.getAirport();
        },
        immediate: false,
      },
    },

    mounted() {
      console.log('this.$route', this.$route);
      this.getAirport();
      this.isLogin && this.getBankLogo();
      // if (this.$route.name === 'Home') {
      //   this.$router.push('/');
      // }
    },
    // updated() {
    //   console.log('this.$route', this.$route)
    // },
    methods: {
      popoverOutsideClick(e) {
        if (e.target.className.includes('search')) return;
        this.isSearchShow && (this.isSearchShow = false);
      },
      getBankLogo() {
        const { userId } = this.userInfo;
        this.$http.account.getBankLogo({ userId }).then(res => {
          this.setHeaderBankLogo(res.data.webHomeLogo);
        });
      },
      toggleSearch() {
        this.isSearchShow = !this.isSearchShow;
      },
      openMenu() {
        this.$mobilePageHeadMenu.show({
          showLoadingModal: true,
          isShowRightWrapper: true,
        });
      },
      handleLounge() {
        this.$router.push({ path: '/lounges' });
      },

      handleBenefits() {
        this.$router.push({ path: '/benefits' });
      },

      isTrustedUrl(url) {
        const trustedDomains = [
          'http://localhost:9099/',
          'https://visa-canada-test.dragonpass.com.cn/',
          'https://visa-canada-uat.dragonpass.com/',
          'https://visa-canada-uat2.dragonpass.com/',
          'https://visaairportcompanion.ca/',
          'https://www.visaairportcompanion.ca/',
          'https://preprod.visaairportcompanion.ca/',
        ];
        return trustedDomains.some(domain => url.startsWith(domain));
      },

      drowDownClick(data) {
        console.log(data, 'lang', data.param === this.$i18n.locale);
        /* eslint-disable */
        const langMap = {
          en_US: 'en',
          fr_CA: 'fr',
        };
        if (this.engDropDownList.length === 1) return;
        if (data.param === this.$i18n.locale) return;
        // this.$i18n.locale = data.param;
        // localStorage.setItem('lang', this.$i18n.locale);
        localStorage.setItem('lang', data.param);
        const url = updateQueryString(window.location.href, 'lang', langMap[data.param]);
        console.log(url, 'url');
        // 解决在别的页面进行切换的时候会造成跳转，触发push的意义在于更新url的信息
        if (this.$route.name === 'Home') {
          // this.$router.push('/');
          // location.reload();
          if (this.isTrustedUrl(url)) {
            window.location.href = url;
          }
        } else {
          // location.reload();
          if (this.isTrustedUrl(url)) {
            window.location.href = url;
          }
        }
      },

      handleUserDropDownList(data) {
        if (data.key === 'lo') {
          this.$messageModal.show({
            i18nNeed: true,
            closeIcon: true,
            desc: 'mbs-ques1',
            confirmBtn: 'btn-confirm',
            cancelBtn: 'btn-cancel',
            justHide: true,
            successCallback: this.handleLogOut,
          });
        } else if (data.key === 'ma') {
          this.$router.push('/account');
        } else if (data.key === 'vp') {
          this.$router.push('/account/places');
        } else if (data.key === 'notify') {
          this.$router.push('/account/notify');
        }
      },
      handleLogOut() {
        store.dispatch('loginModule/logout');
      },
      loginModalShow() {
        this.$router.push('/login');
        // this.$loginModal.show();
      },

      handleSignup() {
        this.$router.push('/sign-up');
      },

      logoClick() {
        if (this.isFromPortal) return;
        this.$router.push('/');
      },

      // TODO: 多处用到可做统一封装
      getAirport() {
        console.log(this.userInfo);
        const { userId, sessionId } = this.userInfo || {};
        const params = {
          lang: this.$i18n.locale,
          userId,
          sessionId,
        };
        this.$http.common.findAllAirport(params).then(res => {
          if (res?.state === '11') {
            this.searchLish = Object.freeze(res.data);
          } else {
            res?.note &&
              this.showMessageModal({
                key: res?.note,
                i18nNeed: false,
              });
          }
        });
      },

      // 点击search item
      handleSearchClick(data) {
        sessionStorage.setItem('searchItem', JSON.stringify(data));
        store.commit('setState', {
          state: 'searchItem',
          values: data,
        });
        this.$router.push({
          path: '/lounges',
          query: { airport: data.name, type: data.type },
        });
        this.isSearchShow = false;
      },

      ...mapMutations(['showMessageModal', 'setHeaderBankLogo']),
    },

    computed: {
      languageTitle() {
        const lang = localStorage.getItem('lang');
        if (this.globalLangList.length) {
          const findItem = this.globalLangList.find(item => item.param === lang);
          return findItem.shortName;
        }
      },

      engDropDownList() {
        const langArr = [];
        // 需要过滤西班牙和波兰语言
        if (this.globalLangList.length) {
          this.globalLangList.forEach(lang => {
            if (lang.param !== 'es_ES' && lang.param !== 'pt_PT') {
              langArr.push({
                id: lang.id,
                label: lang.name,
                param: lang.param,
                key: lang.shortName,
                select: this.$i18n.locale === lang.param,
              });
            }
          });
        }

        return langArr;
      },
      ...mapState(['isLogin', 'userInfo', 'globalLangList', 'bankLogo', 'isFromPortal']),
    },
  };
</script>

<style lang="scss" scoped>
  @use 'index.scss';
</style>
